import { render, staticRenderFns } from "./esta_segui_covid.vue?vue&type=template&id=748e50cf"
import script from "./esta_segui_covid.vue?vue&type=script&lang=js"
export * from "./esta_segui_covid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports